export const TestPageList = [
  /**
   * name:页面名称
   * pageKey:页面key
   * pageSize:页面尺寸
   * testComponent:页面组件
   */
  {
    name: "现场调查",
    pageKey: "survey",
    pageSize: 100,
    testComponent: () =>
      import("@/views/inspectionLite/components/OtherPages/field.vue"),
  },
  {
    name: "生成表格",
    pageKey: "generateTable",
    pageSize: 100,
    testComponent: () =>
      import("@/views/inspectionLite/components/OtherPages/generateTable.vue"),
  },
];
